// =========================================================================
// HD-043 · Configuración del acceso de administración a informes.
//
// El flag vive aquí y no en `lib/clinica-admin.ts` por peso de arranque:
// `MobileScreens` —que sí entra en el bundle inicial— necesita consultarlo para
// decidir si la ruta existe, y si lo importara de la librería arrastraría con
// él todo el cliente HTTP de administración a la descarga de cualquier
// paciente. Este fichero no importa nada.
// =========================================================================

/**
 * Apagada por defecto, como toda función que aún no ha pasado su Tier-2. Aquí
 * lo que falta es la revisión legal del consentimiento para la anotación
 * clínica por administración: sin ella la pantalla no debe existir en
 * producción para nadie, ni siquiera para un superadmin.
 */
export function esAdminInformesActivo(): boolean {
  return String(import.meta.env.VITE_ADMIN_INFORMES ?? '').toLowerCase() === 'true';
}
